if (!customElements.get('iceyard-recently-viewed')) {
  customElements.define('iceyard-recently-viewed', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = new AbortController();
      this.loading = false;
      this.section = this.closest('.shopify-section');
      this.content = this.querySelector('[data-recent-content]');
      this.products = this.querySelector('[data-recent-products]');
      if (!this.section || !this.content || !this.products) return;
      const ids = this.history();
      if (!ids.length) { this.section.hidden = true; return; }
      this.section.hidden = false;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load(ids);
        }, { rootMargin: '600px' });
        this.observer.observe(this);
      } else this.load(ids);
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    history() {
      try {
        const stored = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
        if (!Array.isArray(stored)) return [];
        const ids = [];
        const seen = new Set();
        for (const value of stored) {
          if (!/^[1-9]\d*$/.test(String(value))) continue;
          const id = Number(value);
          if (!Number.isSafeInteger(id) || id === Number(this.dataset.excludeId) || seen.has(id)) continue;
          seen.add(id);
          ids.push(String(id));
          if (ids.length === 50) break;
        }
        return ids;
      } catch { return []; }
    }
    async load(ids) {
      if (this.loading || !ids.length) return;
      this.loading = true;
      const signal = this.abort.signal;
      try {
        const base = `${this.dataset.root.replace(/\/$/, '')}/`;
        const url = new URL(`${base}search`, location.origin);
        url.searchParams.set('type', 'product');
        url.searchParams.set('q', ids.map(id => `id:${id}`).join(' OR '));
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal, priority: 'low' });
        if (!response.ok) throw new Error('history');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (signal.aborted) return;
        const list = html.querySelector('iceyard-recently-viewed [data-recent-products]');
        if (!list) throw new Error('history');
        const allowed = new Set(ids);
        const found = new Set();
        const limit = Math.min(24, Math.max(2, Number(this.dataset.limit) || 6));
        for (const card of list.querySelectorAll('product-card')) {
          const id = card.dataset.recentProductId;
          const handle = card.getAttribute('handle') || '';
          if (!allowed.has(id) || found.has(id) || found.size >= limit || /^option-set-|valgfritt/i.test(handle)) card.remove();
          else found.add(id);
        }
        if (!found.size) { this.section.hidden = true; return; }
        if (!this.isConnected || signal.aborted) return;
        this.products.replaceChildren(...document.importNode(list, true).childNodes);
        this.content.hidden = false;
        this.dataset.loaded = 'true';
      } catch (error) {
        if (!signal.aborted && error.name !== 'AbortError') this.section.hidden = true;
      }
    }
  });
}
